<template>
    <div class="ep-paginator row" v-if="value.total > 0 && value.last_page > 1">
        <div class="col-xs-12 col-sm-8 pagination-wrapper">
            <div class="pagination-inner-wrapper">
                <ul class="pagination mr-6">
                    <li>
                        <a href="" @click.prevent="previousPage" :class="[isFirstPage ? 'disabled': '']" :aria-disabled="isFirstPage"><i class="fa fa-angle-left"></i></a>
                    </li>

                    <li
                        v-for="n in value.last_page"
                        :key="n"
                        v-bind:class="{
                            active: pagination.current_page === n,
                            'hidden-xs hidden-sm':
                                ((pagination.current_page === 1 || pagination.current_page === 2) && n > 5) ||
                                (pagination.current_page >= value.last_page - 1 && n < value.last_page - 4) ||
                                (pagination.current_page > 2 &&
                                    pagination.current_page < value.last_page - 1 &&
                                    (n > pagination.current_page + 2 || n < pagination.current_page - 2)),
                            'hidden-xs hidden-sm hidden-md hidden-lg':
                                ((pagination.current_page === 1 ||
                                    pagination.current_page === 2 ||
                                    pagination.current_page === 3 ||
                                    pagination.current_page === 4 ||
                                    pagination.current_page === 5) &&
                                    n > 11) ||
                                (pagination.current_page >= value.last_page - 5 && n < value.last_page - 10) ||
                                (pagination.current_page > 5 &&
                                    pagination.current_page < value.last_page - 4 &&
                                    (n > pagination.current_page + 5 || n < pagination.current_page - 5)),
                        }"
                    >
                        <a href="" @click.prevent="selectPage(n)">{{ n }}</a>
                    </li>

                    <li>
                        <a href="" @click.prevent="nextPage" :class="[isLastPage ? 'disabled' : '']" :aria-disabled="isLastPage"><i class="fa fa-angle-right"></i></a>
                    </li>
                </ul>

                <span v-if="filteredPerPageOptions.length > 1" class="form-inline hidden-xs mt-7" style="display:inline-block;vertical-align:top;">
                    <select v-model="pagination.limit" class="form-control" style="height: 34px;">
                        <option v-for="option in filteredPerPageOptions" :key="option" :value="option">
                            {{ trans('global.pagination.results_per_page', { number: option }) }}
                        </option>
                    </select>
                </span>
            </div>
            <!-- end col -->
        </div>

        <div class="col-xs-12 col-sm-4 pr-7 mt-4" v-if="value.from && value.to && value.total > 10">
            <p class="text-right clients-list-summary-wrap">
                {{ trans('global.pagination.number_results', { from: value.from, to: value.to, count: value.total }) }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({ current_page: 1, limit: 10, total: 0, last_page: 0, from: 0, to: 0 }),
        },
        perPageOptions: {
            type: Array,
            required: false,
            default: () => [10, 25, 50, 100]
        },
    },
    data () {
        return {
            pagination: this.value,
        }
    },
    methods: {
        nextPage() {
            if (this.isLastPage) return;
            this.pagination.current_page += 1;
            this.$emit('page-changed', this.pagination.current_page);
            this.handleChange();
        },
        previousPage() {
            if (this.isFirstPage) return;
            this.pagination.current_page -= 1;
            this.$emit('page-changed', this.pagination.current_page);
            this.handleChange();
        },
        selectPage (page) {
            this.pagination.current_page = page
            this.$emit('page-changed', this.pagination.current_page);
            this.handleChange();
        },
        handleChange () {
            console.log('change');
            this.$emit('pagination-changed');
        }
    },
    computed: {
        isLastPage() {
            return this.pagination.current_page >= this.pagination.last_page
        },
        isFirstPage() {
            return this.pagination.current_page < 2;
        },
        filteredPerPageOptions () {
            return this.perPageOptions.filter(val => val <= this.value.total)
        }
    },
    watch: {
        value: {
            handler (value) {
                this.pagination = value
            },
            immediate: true
        },
    }
}
</script>
